import { render, staticRenderFns } from "./NotificacionAportesResult.vue?vue&type=template&id=4506bc0a&scoped=true"
import script from "./NotificacionAportesResult.vue?vue&type=script&lang=ts"
export * from "./NotificacionAportesResult.vue?vue&type=script&lang=ts"
import style0 from "./NotificacionAportesResult.vue?vue&type=style&index=0&id=4506bc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506bc0a",
  null
  
)

export default component.exports